import React, { Component } from 'react'
import { connect } from 'react-redux'

import { setFavoritePlant } from '../../actions'

import {
    PlantListItem as ListItem,
    PlantListItemImage,
    PlantListItemContent,
    PlantListItemName,
    PlantListItemLatinName,
    PlantListItemAction
} from '../StyledComponents/Plants/PlantList'

const starIcon = require('../../assets/images/stern-100.png')
const starIconFilled = require('../../assets/images/stern-filled-100.png')

class PlantListItem extends Component {
    constructor(props) {
        super(props)

        this.setFavorite = this.setFavorite.bind(this)
    }

    setFavorite(e) {
        e.preventDefault()

        const { plant, setAsFavorite } = this.props
        setAsFavorite(plant.id)
    }

    render() {
        const { plant, favoritePlants, style } = this.props

        const icon = favoritePlants[plant.id] ? starIconFilled : starIcon

        return (
            <ListItem to={`/plants/${plant.id}`} className="row" style={style}>
                <PlantListItemImage src={plant.image} className="col-4" />
                <PlantListItemContent className="col-8">
                    <PlantListItemName>{plant.localized_name}</PlantListItemName>
                    <PlantListItemLatinName>{plant.name}</PlantListItemLatinName>
                    <PlantListItemAction src={icon} onClick={this.setFavorite} />
                </PlantListItemContent>
            </ListItem>
        )
    }
}

const mapStateToProps = state => ({
    favoritePlants: state.favoritePlants.favorites,
})

export default connect(mapStateToProps, {
    setAsFavorite: setFavoritePlant,
})(PlantListItem)



// WEBPACK FOOTER //
// ./src/components/Plant/PlantListItem.js